import LegalDocumentLayout from './LegalDocumentLayout';
import './LegalDocumentLayout.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

// Actions
import { setLoading } from '../../../redux/loading/actions';

// Redux
const mapStateToProps = (state) => {
  return {};
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    // Loading
    setLoading,
  }, dispatch);
}

const ConnectedLegalDocumentLayout = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(LegalDocumentLayout));

export default ConnectedLegalDocumentLayout;



// WEBPACK FOOTER //
// ./src/pages/LegalDocuments/LegalDocumentLayout/index.js